export default "__VITE_ASSET__B4Do85KG__"